import React from 'react';
import { TextLog } from 'modules/emergencies/components/ui/texts/LogText';
import { LogTitleContainer } from 'modules/emergencies/components/ui/containers/logTitleContainer';
import LogIcon from 'modules/emergencies/components/log/LogIcon';
import t from 'modules/emergencies/components/modals/TicketUpdateTranslations';

const TicketUpdateLogTitle = ({ icon, type }) => {
  return (
    <LogTitleContainer>
      <LogIcon icon={icon} />
      <TextLog color="#263340">{t.logTitle}</TextLog>
      <TextLog color="#54708C">/ {t[type]}</TextLog>
    </LogTitleContainer>
  );
};

export default TicketUpdateLogTitle;
